<template>
  <div
    class="fixed inset-0 z-[100] flex items-center justify-center bg-ink/50 px-4"
  >
    <div ref="dialogPanel" role="dialog" aria-modal="true" :aria-label="$t('routeDetails.gpxModal.downloadButton')" tabindex="-1" @keydown="onDialogKeydown" class="relative w-full max-w-sm paper-card rounded-md p-5">
      <button
        @click="$emit('close')"
        class="absolute top-3 right-3 w-7 h-7 rounded-full flex items-center justify-center hover:bg-[hsl(var(--muted))] transition-colors"
        :aria-label="$t('gradeModal.close')"
      >
        <X class="w-4 h-4" />
      </button>
      <p class="text-[13px] text-[hsl(var(--foreground)/0.8)] leading-relaxed pr-6 mb-4">
        {{ $t('routeDetails.gpxModal.disclaimer') }}
      </p>
      <a
        :href="gpxUrl"
        :download="fileName ?? ''"
        class="w-full h-10 rounded-md bg-[hsl(var(--primary))] text-white text-[13px] font-semibold hover:bg-[hsl(158,38%,30%)] transition-colors flex items-center justify-center gap-1.5"
        @click="trackEvent('Route: Download GPX')"
      >
        <Download class="w-4 h-4" /> {{ $t('routeDetails.gpxModal.downloadButton') }}
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useDialogA11y } from "../composables/useDialogA11y";
import { X, Download } from "lucide-vue-next";
import { trackEvent } from "../analytics";

// fileName - имя файла для локально собранного GPX (blob-ссылка); у серверного
// файла имя задаёт Content-Disposition.
defineProps<{
  gpxUrl: string;
  fileName?: string;
}>();

const emit = defineEmits<{
  (e: "close"): void;
}>();

// Доступность окна: ловушка фокуса, Esc, возврат фокуса (useDialogA11y).
const dialogPanel = ref<HTMLElement | null>(null);
const { titleId: dialogTitleId, onKeydown: onDialogKeydown } = useDialogA11y(dialogPanel, { onClose: () => emit('close') });
</script>
